const messages = {
  title: "Hinnastot ja tuote-esitteet",
  title_media: "Hinnastot ja tuote-esitteet",
  description:
    "Lataa täältä uusimmat esitteet ja flyerit Bridgestone- ja Firestone-renkaistamme henkilöautoihin, SUV-autoihin ja kevytkuorma-autoihin.",
  short_description:
    "Täältä löydät materiaaleja sosiaaliseen mediaan, myymälä-TV:hen ja muuhun.",
  mediaCategories: {
    products: "Tuotteet",
    brand_and_solutions: "Brändi ja ratkaisut",
    season_and_promotions: "Kausi ja kampanjat",
    format: "Formaatti",
    cars_and_vans: "Henkilöauto, SUV, kevyt kuorma-auto",
    truck_and_buses: "Kuorma-auto ja linja-auto",
    motorcycle: "Moottoripyörä",
    agriculture: "Maatalous",
    construction_machinery: "Rakennuskoneet",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materiaalit",
    brochures: "Tuote-esitteet",
    price_list: "Hinnastot",
    materials: "Materiaalit",
    video_in_store: "Video tekstityksillä",
    video_online: "Video ilman tekstityksiä",
    video: "Video",
    banner_website: "Banneri",
    banner_social_media: "Sosiaalinen media",
    logos: "Logot",
    summer: "Kesä",
    winter: "Talvi",
    all_season: "Koko kausi",
    promotions: "Kampanjat",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIAKIRJASTO",
    description:
      "Tervetuloa Bridgestone ja Firestone   \n" +
      "tuotteille omistettuun mediaosioon.  \n <br> <br>" +
      "Löydät tuotteen visuaalisia esityksiä,   \n" +
      "logoja sekä laajan valikoiman   \n" +
      "bannereita, videoita ja digitaalisia materiaaleja   \n" +
      "käytettäväksi verkkosivustollasi tai   \n" +
      "sosiaalisessa mediassa.  ",
    bDrive: {
      title: "Tuotekuvat",
      description:
        "Nykyiset kuvat   \n" +
        "voidaan ladata   \n" +
        "B-\n" +
        "DRIVE-portaalistamme.  ",
    },
  },
  buttons: {
    media: "TUTUSTU",
  },
  searchMedia: "Anna hakusana",
  searchResults: "Hakutulokset",
};

export default {
  messages,
};
